import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled } from "@mui/material/styles";
import {
    Box,
    Button,
    FormControl,
    Grid,
    TextField,
    Stack,
    Typography
} from "@mui/material";
import Select from "react-select";
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect } from "react";
import customStyles from "app/shared-components/SelectCustomStyle";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import moment from "moment/moment";

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& input": {
        padding: "0px 5px !important",
        // padding: "10px 14px",
        //     height: '0.4375em',
    },
    ".muiltr-rboi0c-MuiInputBase-root-MuiOutlinedInput-root": {
        lineHeight: 0.7,
        minHeight: '25px',
    },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    "& input": {
        height: "0.4375em",
    },
    "&.MuiInputBase-root": {
        lineHeight: 1.5,
        minHeight: '27px',
    }
}
))

const TrialBalanceFilter = (props) => {
    const { handleChange, handleSearch, toggleFullScreen } = props
    const [company, setCompany] = useState('1');
    const [companyOptions, setCompanyOptions] = useState([]);
    const [previousPeriodFrom, setPreviousPeriodFrom] = useState('');
    const [previousPeriodTo, setPreviousPeriodTo] = useState('');
    const [masterPeriodFrom, setMasterPeriodFrom] = useState('');
    const [masterPeriodTo, setMasterPeriodTo] = useState('');
    const [selectedCurrency, setSelectedCurrency] = useState('EUR');
    const [currencyOptions, setCurrencyOptions] = useState([]);


    useEffect(() => {
        const currencies = async () => {
            const currencyUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.currencies}`
            const list = await OAuthService.getList(currencyUrl);
            if (list?.data) {
                const options = list?.data?._embedded?.currencies.map((data) => {
                    props.setFilterData(prevValues => ({
                        ...prevValues,
                        ["currency"]: data.name
                    }))
                    return { label: data.name, value: data.name }
                })
                setCurrencyOptions(options)
            }
        }
        currencies();

        const partnerOpt = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
            const partners = await OAuthService.getList(url + `/search/findByCustomerTypes?customerTypes=FRANCHISE&customerTypes=NOLTEFZE`);
            const result = partners?.data?._embedded?.companies.map((value) => {
                props.setFilterData(prevValues => ({
                    ...prevValues,
                    ["companyCode"]: value.id.toString()
                }))
                return { label: value.name, value: value.id, refNumber: value.vendorCustomerRef }
            })
            setCompanyOptions(result);
        }
        partnerOpt();
    }, [])

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <div className="flex">
                    <FormControl className="flex flex-row">
                        <Grid container spacing={2}>
                            <Grid item md={2} lg={2}>
                                {/* <div className="mr-16">
                                    <label>Company</label>
                                    <StyledTextField type="text" variant="outlined" fullWidth name="company" value={company}
                                        onChange={(e) => { setCompany(e.target.value); 
                                        handleChange(e) }} />
                                </div> */}
                                <Stack>
                                    <label className="basis-0 float-left">*Company</label>
                                    <Select
                                        name='companyCode'
                                        value={(company && companyOptions) && companyOptions.find((data) => Number(data.value) === Number(company))}
                                        isDisabled={true}
                                        options={companyOptions}
                                        onChange={(e) => {handleChange(e, "company")}}
                                        styles={customStyles()}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label className="basis-0 float-left">Previous Period </label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'prevStartDate'}
                                        value={previousPeriodFrom}
                                        handleChange={(value) => {
                                            setPreviousPeriodFrom(moment(value).format('YYYY-MM-DD'));
                                            handleChange(value, "prevStartDate")
                                        }}
                                        disableFuture={true}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label className="basis-0 float-left">Previous Period </label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'prevEndDate'}
                                        value={previousPeriodTo}
                                        handleChange={(value) => {
                                            setPreviousPeriodTo(moment(value).format('YYYY-MM-DD'));
                                            handleChange(value, "prevEndDate")
                                        }}
                                        disableFuture={true}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                    <Typography
                                        className="text-[#f44336] text-sm ml-14">{(props.error === "prevEndDate") ? "Previous Period must be lower then Master Period " : ""}</Typography>
                                </div>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label className="basis-0 float-left">*Master Period </label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'startDate'}
                                        value={masterPeriodFrom}
                                        handleChange={(value) => {
                                            setMasterPeriodFrom(moment(value).format('YYYY-MM-DD'));
                                            handleChange(value, "startDate")
                                        }}
                                        disableFuture={true}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                    <Typography
                                        className="text-[#f44336] text-sm ml-14">{(props.error === "masterFrom" && masterPeriodFrom === "") ? "This field is required" : ""}</Typography>
                                </div>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label className="basis-0 float-left">*Master Period </label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'endDate'}
                                        value={masterPeriodTo}
                                        handleChange={(value) => {
                                            setMasterPeriodTo(moment(value).format('YYYY-MM-DD'));
                                            handleChange(value, "endDate")
                                        }}
                                        disableFuture={true}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                    <Typography
                                        className="text-[#f44336] text-sm ml-14">{(props.error === "masterTo" && masterPeriodTo === "") ? "This field is required" : ""}</Typography>
                                </div>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className=" basis-0 float-left">*Currency</label>
                                    {/* <FormControl sx={{ width: 200 }} > */}
                                    <Select
                                        name="currency"
                                        value={(currencyOptions.length > 0 && selectedCurrency) && currencyOptions.filter((data) => data.value === selectedCurrency)}
                                        // error={validError.currency ? true : false}
                                        onChange={(e) => {
                                            setSelectedCurrency(e.value);
                                            handleChange(e, "currency")
                                        }}
                                        isDisabled={false}
                                        options={currencyOptions}
                                        styles={customStyles()}
                                    >
                                    </Select>
                                    {/* </FormControl> */}
                                    {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label style={{ visibility: "hidden" }}>Period</label>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{ mt: 2, height: "25px" }}
                                        onClick={() => handleSearch()}
                                    >
                                        <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label style={{ visibility: "hidden" }}>Period</label>
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        size="small"
                                        onClick={() => toggleFullScreen()}
                                        style={{ marginTop: '10px', fontWeight: 'bold', height: "25px" }}
                                    >
                                        View Table
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </FormControl>
                </div>
            </Box>
        </>
    )
}

export default TrialBalanceFilter;
